export function generateEmptyItemsArray(minItems: number, itemsCarouselLength: number) {
  const emptyItems = minItems - itemsCarouselLength;
  const emptyItemsArray = Array.from({ length: emptyItems }, (_, i) => i + (minItems - emptyItems + 1));
  return emptyItemsArray;
}
